module.exports = require('./src/Scripts/jquery.fileDownload');



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery-file-download/index.js
// module id = /rcA
// module chunks = 0